import { Domain } from "../constants";

export const COOKIE_SETTINGS = {
  path: "/",
  secure: true,
  domain: Domain, 
sameSite: "None"
};

export const getCookieSettingsString = () => {
  return `path=${COOKIE_SETTINGS.path}; Secure; domain=${COOKIE_SETTINGS.domain}; SameSite=${COOKIE_SETTINGS.sameSite}`;
};

// export const setCookie = (name, value, days = 1) => {
//   const expires = new Date(Date.now() + days * 864e5).toUTCString();
//   document.cookie = `${name}=${encodeURIComponent(
//     JSON.stringify(value)
//   )}; expires=${expires}; ${getCookieSettingsString()}`;
// };


export const setCookie = (name, value, days = 1) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    JSON.stringify(value)
  )}; expires=${expires}; path=/; domain=.myskill.club; Secure; SameSite=None`;
};


export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? JSON.parse(decodeURIComponent(match[2])) : null;
};

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${getCookieSettingsString()}`;
};
